module.exports = __webpack_public_path__ + "img/img_detail42.952804f4.png";